
import { Fragment, useState} from 'react';
import { useAuth } from "../app/context";
import {ReactComponent as LogoIcon} from '../assets/images/apv.svg';


const NavMenu = ({onClick,children}) => {
  return <button onClick={onClick} className="block-auto h-60 
      font-inter fw-500 fs-16 lg:fs-16 lh-none hover:fw-600
      hover:color-highlight-1 color-highlight-2 bw-0 bw-b-2 bs-solid bc-transparent hover:bc-highlight-1 transition-fast">
      {children}
    </button>
}

const NavMenuSm = ({onClick,children}) => {
  return <button onClick={onClick} className="block-full  
      font-inter fw-500 fs-18 lh-none text-left pl-24 py-20
      hover:color-highlight-1 color-highlight-2 transition-fast shadow-sm bw-0 bw-t-1 bs-solid bc-highlight-2">
      {children}
    </button>
}
const Hero = () =>{

  let { isLoaded, personal,photos,lang,setLang,translations } = useAuth();  
  
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  
  const scrollToSection = (sectionId) => {
    let element = document.getElementById(sectionId);
    
    if (element) {
      let navHeight = 64;
      let elementPosition = element.getBoundingClientRect().top;
      let offsetPosition = elementPosition + window.pageYOffset - navHeight;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
    setMobileMenuOpen(false);
  };

  const handlephotosBtn = (e) =>{
    e.preventDefault();
    e.stopPropagation();
    if(!isLoaded) return;
    let element = document.getElementById("photo-btn");    
    if(element){
      element.click();
    }
  }
  return(
    <Fragment >

      <nav className="block-full fixed top-0 bg-white z-index-100 shadow-lg">
        <div className="flex-row-full h-64 max-w-1200 px-12 sm:px-16 md:px-32 mx-auto items-center justify-space-between">
          <button 
            className="block-auto fw-700 font-inter fs-24 lh-none fill-highlight-2 hover:fill-highlight-1 cursor-pointer" 
            onClick={() => scrollToSection('hero-section')}
          >
            <LogoIcon className="block-60 h-auto"/>
          </button>
          <div className="flex-row-auto md:flex none gap-28 lg:gap-48">
            <NavMenu onClick={() => scrollToSection('personal')} >{translations.nav.menu[0]}</NavMenu>
            <NavMenu onClick={() => scrollToSection('education')} >{translations.nav.menu[1]}</NavMenu>
            <NavMenu onClick={() => scrollToSection('professional')} >{translations.nav.menu[2]}</NavMenu>
            <NavMenu onClick={() => scrollToSection('skills')} >{translations.nav.menu[3]}</NavMenu>
            <NavMenu onClick={() => scrollToSection('family')} >{translations.nav.menu[4]}</NavMenu>
            <NavMenu onClick={() => scrollToSection('spiritual')} >{translations.nav.menu[5]}</NavMenu>
            <NavMenu onClick={() => scrollToSection('contact')} >{translations.nav.menu[6]}</NavMenu>
          </div>

          {!!mobileMenuOpen && <div className="flex-column-full sm:w-f50 max-w-300 sm:max-w-320 md:none fixed right-0 bottom-0 top-64 bg-white shadow-sm">
            <NavMenuSm onClick={() => scrollToSection('personal')} >{translations.nav.menu[0]}</NavMenuSm>
            <NavMenuSm onClick={() => scrollToSection('education')} >{translations.nav.menu[1]}</NavMenuSm>
            <NavMenuSm onClick={() => scrollToSection('professional')} >{translations.nav.menu[2]}</NavMenuSm>
            <NavMenuSm onClick={() => scrollToSection('skills')} >{translations.nav.menu[3]}</NavMenuSm>
            <NavMenuSm onClick={() => scrollToSection('family')} >{translations.nav.menu[4]}</NavMenuSm>
            <NavMenuSm onClick={() => scrollToSection('spiritual')} >{translations.nav.menu[5]}</NavMenuSm>
            <NavMenuSm onClick={() => scrollToSection('contact')} >{translations.nav.menu[6]}</NavMenuSm>
          </div>}

          <button 
            className="block-auto md:none fs-24 fw-500 hover:color-dark color-teal-accent transition-fast"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            ☰
          </button>
        </div>
      </nav>

      <div id="hero-section" className="flex-column-full justify-center items-center py-72 m:py-96 mt-64 text-center" style={{background: "var(--gradient-hero)"}}>

        <div className="block-200 h-200 md:w-300 md:h-300 br-round p-4 gradient-bc-a zoom-6 transition-fast shadow-md mb-32 overflow-hidden">
          <div className="flex-row-full justify-center items-center h-full bg-white br-round" onClick={handlephotosBtn}>
            {!!photos[0] && <img 
              src={photos[0]}
              alt="Profile Photo"
              className="block br-round" 
            />}

            {!photos[0] && <div className="block-f50 fill-header-2">
              <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><circle cx="12" cy="3" r="1"><animate id="spinner_7Z73" begin="0;spinner_tKsu.end-0.5s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="16.50" cy="4.21" r="1"><animate id="spinner_Wd87" begin="spinner_7Z73.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="7.50" cy="4.21" r="1"><animate id="spinner_tKsu" begin="spinner_9Qlc.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="19.79" cy="7.50" r="1"><animate id="spinner_lMMO" begin="spinner_Wd87.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="4.21" cy="7.50" r="1"><animate id="spinner_9Qlc" begin="spinner_Khxv.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="21.00" cy="12.00" r="1"><animate id="spinner_5L9t" begin="spinner_lMMO.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="3.00" cy="12.00" r="1"><animate id="spinner_Khxv" begin="spinner_ld6P.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="19.79" cy="16.50" r="1"><animate id="spinner_BfTD" begin="spinner_5L9t.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="4.21" cy="16.50" r="1"><animate id="spinner_ld6P" begin="spinner_XyBs.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="16.50" cy="19.79" r="1"><animate id="spinner_7gAK" begin="spinner_BfTD.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="7.50" cy="19.79" r="1"><animate id="spinner_XyBs" begin="spinner_HiSl.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><circle cx="12" cy="21" r="1"><animate id="spinner_HiSl" begin="spinner_7gAK.begin+0.1s" attributeName="r" calcMode="spline" dur="0.6s" values="1;2;1" keySplines=".27,.42,.37,.99;.53,0,.61,.73"/></circle><animateTransform attributeName="transform" type="rotate" dur="6s" values="360 12 12;0 12 12" repeatCount="indefinite"/></g></svg>
            </div>}
          </div>
        </div>    
            
        {!!isLoaded && <div className="block-auto fw-700 font-inter fs-32 lh-48 md:fs-48 md:lh-64 mb-8 md:mb-16 mx-auto gradient-text-a">{personal.name}</div>}
        {!!isLoaded && <div className="block-auto fw-500 font-inter fs-16 md:fs-20 lh-24 mb-20 md:mb-32 mx-auto color-gray">{personal.tagline}</div>}
        <div className="flex-row-auto gap-12 md:gap-16 ">
          <button 
            className="block-150 md:w-200 br-12 px-12 py-16 md:px-24
                  font-inter fs-16 fw-500 lh-none
                  bg-white hover:bg-highlight-3 color-highlight-3 hover:color-white
                  shadow-md hover:shadow-lg zoom-2 transition-slow shrink-0" 
            onClick={() => scrollToSection('personal-info')}
          >
            {translations.hero.btns[0]}
          </button>
          <button 
              className="block-150 md:w-200 br-12 px-12 py-16 md:px-24
                    font-inter fs-16 fw-500 lh-none
                    bg-highlight-3 hover:bg-white color-white hover:color-highlight-3
                    shadow-md hover:shadow-lg zoom-2 transition-slow shrink-0"
              onClick={() => scrollToSection('contact')}
            >
              {translations.hero.btns[1]}
            </button>
        </div>


<label className="block-auto cursor-pointer br-24 shadow-md hover:shadow-lg mt-24 md:mt-32 select-none" htmlFor="lang-hi">
  <input 
    id="lang-hi"
    type="checkbox" 
    className="block-auto w-0 h-0 opacity-0"
    checked={lang === 'en'}
    onChange={(e) => setLang(e.target.checked)}
  />  
  <div className="flex-row-200 br-24 overflow-hidden">
    <div className={`block-f50 shrink-0 font-inter fs-16 fw-500 lh-none py-12 transition-slow ${
      lang === 'en' 
        ? 'bg-highlight-3 color-white' 
        : 'bg-white color-highlight-3'
    }`}>
      English
    </div>
    <div className={`block-f50 shrink-0 font-inter fs-16 fw-500 lh-none py-12 transition-slow ${
      lang === 'hi' 
         ? 'bg-highlight-3 color-white' 
        : 'bg-white color-highlight-3'
    }`}>
      हिंदी
    </div>
  </div>
</label>




      </div>

    </Fragment>
  )
}

export default Hero;
